module.exports = __webpack_public_path__ + "img/icon_dashboard_computerroom.36959533.svg";